import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SearchIcon from '@mui/icons-material/Search';
import {
  Grid,
  IconButton,
  ThemeProvider,
} from '@mui/material';
import {
  useQueryClient,
} from '@tanstack/react-query';
import {
  createFileRoute,
} from '@tanstack/react-router';
import {
  useEffect,
  useState,
} from 'react';
import {
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import {
  useAuth,
} from 'react-oidc-context';

import {
  darkTheme,
} from '#components/themes';
import {
  ImageButton,
} from '#components/ui';
import CreateWorkpaperTemplate from '#pages/Gary/Settings/CreateWorkpaperTemplate';
import TemplateDetailModal from '#pages/Gary/Settings/TemplateDetailModal';
import {
  formatDateTimeStr,
} from '@specia-accountant/shared';
import {
  resolveObject,
} from '@specia-accountant/shared';

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/template',
)({
  component: RouteComponent,
  loader: async (opts): Promise<LoaderDataResult> => {
    const tabData: Promise<LoaderDataResult['requests']> = opts.context.queryClient.ensureQueryData({
      queryKey: [
        'creator',
        'template',
      ],
    });
    const result = await resolveObject({
      tabData,
    });
    return result;
  },
});

function RouteComponent() {
  const {
    tabData,
  } = Route.useLoaderData();
  const queryClient = useQueryClient();
  const labels = [
    'General Ledger',
    'Balance Sheet',
    'Profit & Loss',
    'Wages',
    'Wages PAS',
    'Debtor',
    'Creditor',
    'Interest & Penalty',
    'Income Tax Statement (IT)',
    'Integrated Client Account (AS)',
    'GST',
    'GST Rec',
    'FR ACC',
  ];
  const auth = useAuth() as unknown as RootRouterAuthContext;
  const [
    detailModalShown,
    setDetailModalShown,
  ] = useState(false);
  const [
    currentTemplateId,
    setCurrentTemplateId,
  ] = useState('');
  const [
    currentTemplate,
    setCurrentTemplate,
  ] = useState('');
  const [
    currentCustomName,
    setCurrentCustomName,
  ] = useState('');
  const [
    createTemplateShow,
    setCreateTemplateShow,
  ] = useState(false);
  function closeDetailModalHandler() {
    setDetailModalShown(false);
  }
  const [
    isEditing,
    setIsEditing,
  ] = useState(false);
  const [
    selectAll,
    setSelectAll,
  ] = useState(false);
  const [
    checkedItems,
    setCheckedItems,
  ] = useState(
    labels.reduce(
      (acc, label) => {
        acc[label] = false;
        return acc;
      },
      {},
    ),
  );
  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setCheckedItems(
      labels.reduce(
        (acc, label) => {
          acc[label] = !selectAll;
          return acc;
        },
        {},
      ),
    );
  };
  const handleChange = (label) => {
    setCheckedItems((prevState) => {
      const newCheckedItems = {
        ...prevState,
        [label]: !prevState[label],
      };
      const allSelected = labels.every(l => newCheckedItems[l]);
      setSelectAll(allSelected);
      return newCheckedItems;
    });
  };
  const [
    tableData,
    setTableData,
  ] = useState(tabData);
  const [
    currentPage,
    setCurrentPage,
  ] = useState(1);
  const itemsPerPage = 5;
  let indexOfLastItem = currentPage * itemsPerPage;
  let indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const [
    currentItems,
    setCurrentitems,
  ] = useState(tabData.slice(indexOfFirstItem, indexOfLastItem));
  // Page change handlers
  const nextPage = () => {
    if (currentPage < Math.ceil(tableData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const fetchData = () => {
    return queryClient.invalidateQueries({
      queryKey: [
        'creator',
        'template',
      ],
    });
  };
  const handleOpenCreateTemplate = () => {
    setCreateTemplateShow(true);
  };
  useEffect(() => {
    setTableData(tabData);
    console.info(`Set table data:`, tabData);
    // Calculate the items for the current page
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentitems(
      tabData.slice(
        indexOfFirstItem,
        indexOfLastItem,
      ),
    );
  },
  [
    tabData,
    currentPage,
  ],
  );
  useEffect(() => {
    // Calculate the items for the current page
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentitems(tabData.slice(indexOfFirstItem, indexOfLastItem));
  }, [
    tabData,
    currentPage,
  ]);
  return (
    <>
      <CreateWorkpaperTemplate
        show={ createTemplateShow }
        onHide={ () => { setCreateTemplateShow(false); } }
        onRefresh={ fetchData }
      />
      <>
        <div
          style={ {
            textAlign: 'left',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: '1.5vw',
            width: '100%',
          } }
        >
          <div
            style={ {
              backgroundColor: 'rgb(255, 255, 255, 0.08)',
              borderRadius: '50px',
              padding: '0.2vw',
            } }
          >
            <ThemeProvider
              theme={ darkTheme }
            >
              <IconButton
                aria-label="delete"
                style={ {
                  backgroundColor: 'rgb(255, 255, 255, 0.15)',
                  padding: '0.5vw',
                  fontSize: '0.5vw',
                  color: 'rgb(255, 255, 255, 0.7)',
                  cursor: 'none',
                } }
              >
                <SearchIcon
                  style={ {
                    fontSize: '1vw',
                  } }
                />
              </IconButton>
            </ThemeProvider>
            <Form.Control
              style={ {
                display: 'inline',
                backgroundColor: 'rgba(255,255,255,0)',
                padding: 0,
                paddingLeft: '0.8vw',
                paddingRight: '0.8vw',
                border: '1px solid rgb(255, 255, 255, 0)',
                borderRadius: '6px',
                fontSize: '0.9vw',
                maxWidth: '80%',
                marginLeft: '0',
                fontWeight: '200',
              } }
              className="shadow-none"
              type="text"
              placeholder="Search"
              // value={searchQuery}
              // onChange={}
            />
          </div>
          <div
            style={ {
              flex: 1,
              textAlign: 'right',
              paddingLeft: '0.5vw',
            } }
          >
            <OverlayTrigger
              key="top-submit"
              placement="top"
              overlay={ (
                <Tooltip
                  id="tooltip-submit"
                >
                  Create Template
                </Tooltip>
              ) }
            >
              <IconButton
                variant="text"
                style={ {
                  fontSize: '0.9vw',
                  cursor: 'pointer',
                  padding: '0.75vw',
                  minWidth: 0,
                  borderRadius: '2vw',
                  backgroundColor: 'rgb(255, 255, 255, 0.1)',
                  marginLeft: '1vw',
                } }
                onClick={ handleOpenCreateTemplate }
              >
                <AddIcon
                  style={ {
                    fontSize: '0.95vw',
                    fill: '#ffffff',
                  } }
                  className="fill-white stroke-white"
                >
                </AddIcon>
              </IconButton>
            </OverlayTrigger>
          </div>
        </div>
        <div
          style={ {
            margin: '0.5vw 0',
            marginTop: '0',
            padding: 0,
            fontSize: '1.6rem',
            borderRadius: '5vw',
          } }
        >
          <div
            style={ {
              width: '100%',
              textAlign: 'left',
            } }
          >
            <Grid
              container
              spacing={ 2 }
            >
              { currentItems.map((row, index) => {
                return (
                  <Grid
                    item
                    xs={ 6 }
                    key={ index }
                    spacing={ 1 }
                  >
                    <ImageButton
                      focusRipple
                      style={ {
                        width: '100%',
                        textAlign: 'left',
                        borderRadius: '1.2vw',
                      } }
                    >
                      <div
                        style={ {
                          width: '100%',
                          backgroundColor: 'rgb(255, 255, 255, 0.06)',
                          borderRadius: '1.2vw',
                          cursor: 'pointer',
                          border: '0.05vw solid rgb(255, 255, 255, 0)',
                        } }
                        onClick={ () => {
                          console.log(row);
                          setCurrentTemplate(row);
                          setCurrentTemplateId(row.id);
                          setDetailModalShown(true);
                        } }
                      >
                        <div
                          style={ {
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                          } }
                        >
                          <IconButton
                            style={ {
                              margin: '1vw',
                              backgroundColor: 'rgb(255, 255, 255, 0.06)',
                            } }
                            disabled
                          >
                            <ContentCopyIcon
                              style={ {
                                margin: '0.5vw',
                                fontSize: '2vw',
                                color: 'rgb(255, 255, 255, 0.5)',
                              } }
                            />
                          </IconButton>
                          <div
                            style={ {
                              flex: 1,
                              padding: '0.5vw',
                              paddingLeft: '0',
                            } }
                          >
                            <p
                              style={ {
                                fontSize: '0.9vw',
                                margin: 0,
                                lineHeight: '1.5vw',
                                fontWeight: '600',
                                color: 'rgb(255, 255, 255, 0.9)',
                              } }
                            >
                              { row.name }
                            </p>
                            <p
                              style={ {
                                fontSize: '0.75vw',
                                lineHeight: '1.5vw',
                                margin: 0,
                                fontWeight: '400',
                                color: 'rgb(255, 255, 255, 0.7)',
                              } }
                            >
                              Last Modified:
                              { formatDateTimeStr(row.lastModified) }
                            </p>
                          </div>
                        </div>
                      </div>
                    </ImageButton>
                  </Grid>
                );
              }) }
            </Grid>
            <div
              style={ {
                marginTop: '1vw',
                marginLeft: '0vw',
                marginRight: '0vw',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                textAlign: 'left',
              } }
            >
              <div
                style={ {
                  flex: 1,
                } }
              >
                <p
                  style={ {
                    color: 'rgb(255, 255, 255, 0.6)',
                    fontSize: '0.9vw',
                    marginLeft: '0.2vw',
                    marginTop: '1vw',
                  } }
                >
                  Showing
                  { ' ' }
                  { indexOfFirstItem + 1 }
                  { ' ' }
                  to
                  { indexOfLastItem > tableData.length ? tableData.length : indexOfLastItem }
                  { ' ' }
                  of
                  { tableData.length }
                  { ' ' }
                  entries
                </p>
              </div>
              <div
                style={ {
                  display: 'flex',
                  alignItems: 'center',
                } }
              >
                <button
                  onClick={ prevPage }
                  disabled={ currentPage === 1 }
                  style={ {
                    width: '2.5vw',
                    height: '2.5vw',
                    borderRadius: '0.5vw',
                    marginRight: '6px',
                    color: currentPage === 1 ? 'gray' : 'white',
                    backgroundColor: 'rgb(255, 255, 255, 0.02)',
                    border: '0.5px solid rgb(255, 255, 255, 0.3)',
                    // color: 'white',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9vw',
                  } }
                >
                  <ArrowBackIcon />
                </button>

                <button
                  onClick={ nextPage }
                  disabled={ currentPage === Math.ceil(tableData.length / itemsPerPage) }
                  style={ {
                    width: '2.5vw',
                    height: '2.5vw',
                    borderRadius: '0.5vw',
                    marginLeft: '6px',
                    color: 'white',
                    backgroundColor: 'rgb(255, 255, 255, 0.02)',
                    border: '0.5px solid rgb(255, 255, 255, 0.3)',
                    cursor: currentPage === Math.ceil(tableData.length / itemsPerPage) ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9vw',
                  } }
                >
                  <ArrowForwardIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
      <TemplateDetailModal
        show={ detailModalShown }
        onClose={ closeDetailModalHandler }
        tabId={ currentTemplateId }
        template={ currentTemplate }
        customName={ currentCustomName }
        fetchDataHandler={ fetchData }
      />
    </>
  );
}
